import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  /* GET, PUT AND POST creators/me */
  getMyCreatorProfileAPI() {
    return gemmiciApiServiceClient.get("/creators/me");
  },
  putMyCreatorProfileAPI(payload) {
    return gemmiciApiServiceClient.put("creators/me", payload);
  },
  createMyCreatorProfileAPI(username, uuid) {
    return gemmiciApiServiceClient.post("creators", {
      username: username,
      uuid: uuid
    });
  },
  /*  */
  getCreatorProfileAPI(username) {
    return gemmiciApiServiceClient.get("creators", {
      params: {
        username: username
      }
    });
  },
  /*  */
  postProfilePictureAPI(picture) {
    return gemmiciApiServiceClient.post("profile_picture", picture, {
      headers: {
        "Content-type": "multipart/form-data"
      }
    });
  },
  /* GET creator posts */
  getCreatorPosts(username) {
    return gemmiciApiServiceClient.get("creator/posts", {
      params: {
        username: username,
        posts_per_page: 100,
        page: 1
      }
    });
  },
  checkCreatorRegistrationCode(uuid) {
    return gemmiciApiServiceClient.get("creators/register/" + uuid);
  }
};
